// extracted by mini-css-extract-plugin
export var ldsDefault = "_redotech-redo-customer-portal-app-src-portal-four-returns-spinner-lds-default";